import React, { Component } from 'react';
import {
    Switch,
    Route
} from 'react-router-dom';
import { connect } from "react-redux";
// dinamically create app routes
import appRoutes from 'routes/app.jsx';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute'

class App extends Component {
    componentDidUpdate(e) {
        if (window.innerWidth < 993 && e.history.action === "PUSH" && document.documentElement.className.indexOf('nav-open') !== -1) {
            document.documentElement.classList.toggle('nav-open');
        }
    }
    render() {
        return (
            <Switch>
                {
                    appRoutes.map((prop, key) => {
                        if (prop.role) {
                            const { path, component, role } = prop;
                            return <ProtectedRoute  path={path} component={component} role={role} />
                        } else {
                            return (
                                <Route path={prop.path} component={prop.component} key={key} />
                            );
                        }
                    })
                }
            </Switch>
        );
    }
}

const mapStateToProps = (state) => {
    return state;
  };
  
  export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.jsx